import type { Columns } from '@lemonade-hq/uniclient-chat';
import { useViewportSize } from '@lemonade-hq/uniclient-theme';
import type { PropsWithChildren } from 'react';
import { WizardLayoutContainer } from './WizardLayoutContainer';

interface WizardSideGridProps {
  readonly columns: Columns;
  readonly className?: string;
  readonly showOnMobile?: boolean;
}

export const WizardSideGrid: React.FC<PropsWithChildren<WizardSideGridProps>> = ({
  columns,
  children,
  className,
  showOnMobile = false,
}) => {
  const { isBelowDesktopViewport } = useViewportSize();
  if (isBelowDesktopViewport && !showOnMobile) {
    return null;
  }

  return (
    <WizardLayoutContainer className={className} columns={columns}>
      {children}
    </WizardLayoutContainer>
  );
};
